// Defines <svg-image> synchronously, before the rest of the page parses.
// Loaded (without `defer`) at the very top of theme.liquid's <head> instead
// of from global.js (which loads `defer`). The header logo renders as a
// plain <img> first and this element swaps it for inline SVG once fetched;
// waiting for global.js to download/parse/execute meant the swap always
// happened after first paint, visible as a blink. Defining the element this
// early lets the parser upgrade <svg-image> the moment it hits the header
// markup, so the fetch starts as soon as possible.
(function () {
  var svgImageFetchCache = new Map();

  function fetchSvgImage(url) {
    if (!svgImageFetchCache.has(url)) {
      svgImageFetchCache.set(
        url,
        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .catch(function (error) {
            console.error('Error fetching SVG:', error);
            return null;
          })
      );
    }
    return svgImageFetchCache.get(url);
  }

  class SvgImage extends HTMLElement {
    connectedCallback() {
      // connectedCallback (not the constructor) - it can re-fire if the
      // element is moved in the DOM, so guard against loading twice.
      if (this._svgImageStarted) return;
      this._svgImageStarted = true;

      var el = this;

      var watchViewportThenLoad = function (mainDiv, imageUrl) {
        var load = function () {
          fetchSvgImage(imageUrl).then(function (svgText) {
            if (svgText != null) mainDiv.innerHTML = svgText;
            el.classList.add('svg-image-loaded');
          });
        };

        // Instances already in (or near) the viewport at load - the header
        // logo, a PDP thumbnail - load immediately. Instances that start
        // off-screen - every one of them in the footer, on first paint of
        // any page - wait until the user scrolls near them, so their
        // network requests don't compete with the initial critical-path
        // fetches at all.
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
              observer.disconnect();
              load();
            }
          }, { rootMargin: '200px' });
          observer.observe(el);
        } else {
          load();
        }
      };

      var start = function (mainDiv) {
        var imageUrl = mainDiv.getAttribute('data-image-url');
        if (!imageUrl) return;
        watchViewportThenLoad(mainDiv, imageUrl);
      };

      var mainDiv = this.querySelector('.collection-logo');
      if (mainDiv) {
        start(mainDiv);
        return;
      }

      // This script loads without `defer`, so it runs - and the parser
      // upgrades <svg-image>, firing this callback - the instant it sees the
      // opening tag, before its child `.collection-logo` div has been
      // parsed, so mainDiv is null on the first try. The child shows up
      // moments later in the same parsing pass, so watch for it instead of
      // assuming it's already there.
      var childObserver = new MutationObserver(function () {
        var found = el.querySelector('.collection-logo');
        if (found) {
          childObserver.disconnect();
          start(found);
        }
      });
      childObserver.observe(this, { childList: true });
    }
  }
  customElements.define('svg-image', SvgImage);
})();
